module.exports = __webpack_public_path__ + "static/media/Quick_Transfer.78638a83.svg";